var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationStalled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_776_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51496 7.51458C2.82867 12.2009 2.82867 19.7988 7.51496 24.4851C12.2013 29.1714 19.7992 29.1714 24.4855 24.4851C29.1718 19.7988 29.1718 12.2009 24.4855 7.51458C19.7992 2.82829 12.2013 2.82829 7.51496 7.51458Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0099 9L16.0099 18M16.01 21L16.01 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_776_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationStalled);
export default __webpack_public_path__ + "static/media/exclamation_stalled.60e7bd04bb0f6691c700a3c40160a915.svg";
export { ForwardRef as ReactComponent };